export default class Globals {
	public static apiKey: string;
	public static apiUrl: string;
	public static customerId: string;
}
